import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_layout_footer = _resolveComponent("vxe-layout-footer");
  return _openBlock(), _createBlock(_component_vxe_layout_footer, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
    _: 3
  }, 16);
}